// extracted by mini-css-extract-plugin
module.exports = {"main":"EditUser_main__37tfb"};